var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg3Rdretailicons7(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.79 15.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 7.89,
    cy: 7.89,
    r: 7.89,
    style: {
      fill: "#1e3f76",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.88,14a.33.33,0,0,1-.17,0L16,13.6a.38.38,0,0,1,.34-.68l.76.38a.37.37,0,0,1,.17.51A.37.37,0,0,1,16.88,14Zm-.59-3.46.76-.38a.38.38,0,1,0-.34-.68h0L16,9.88a.38.38,0,0,0-.17.51A.37.37,0,0,0,16.29,10.56Zm1,1.18a.38.38,0,0,0-.38-.38h-.76a.38.38,0,0,0,0,.76h.76A.38.38,0,0,0,17.26,11.74ZM15,15.16V8.32a.38.38,0,1,0-.76,0c0,1.12-1,1.52-1.9,1.52H9.66a1.52,1.52,0,0,0-1.52,1.52v.76a1.52,1.52,0,0,0,1.52,1.52h2.66c.92,0,1.9.4,1.9,1.52a.38.38,0,0,0,.76,0Zm-3.73-.76H9.66a2.24,2.24,0,0,1-.52-.06l.95,2.12a1,1,0,0,0,.92.6.94.94,0,0,0,.94-.94,1,1,0,0,0-.08-.38Z",
    transform: "translate(-4.64 -4.61)",
    style: {
      fill: "#171c32"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3Rdretailicons7);
export default __webpack_public_path__ + "static/media/3rdretailicons7.165aed7222e7fa95fb7e206a7ef2ef9a.svg";
export { ForwardRef as ReactComponent };